import { render, staticRenderFns } from "./RenrenButton.vue?vue&type=template&id=70b0249b&scoped=true&"
import script from "./RenrenButton.vue?vue&type=script&lang=js&"
export * from "./RenrenButton.vue?vue&type=script&lang=js&"
import style0 from "./RenrenButton.vue?vue&type=style&index=0&id=70b0249b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0249b",
  null
  
)

export default component.exports